import React, { PointerEventHandler, useCallback } from 'react';
import { ClientType } from '@common/model/client/clientType';
import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { cx } from '@emotion/css';
import { CLIENT_TYPE_TO_CLIENT_TYPE_NAME, EButtonName, useTrackMount } from 'src/shared/tracking';
import { StepContainer } from '../StepContainer';
import { ClientTypeModalOpen } from '../../lib';
import { ClientRegistrationStepProps } from './model';

export const StepClientType = ({ onSubmit }: ClientRegistrationStepProps) => {
  useTrackMount(ClientTypeModalOpen);
  const onClick: PointerEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      const value = e.currentTarget.value;
      return onSubmit({ clientType: Number(value) });
    },
    [onSubmit],
  );
  return (
    <StepContainer>
      <Stack direction="row" justifyContent="center" mt={2} spacing={1}>
        <Button
          className={cx(EButtonName.SelectClientType, CLIENT_TYPE_TO_CLIENT_TYPE_NAME[ClientType.Employer])}
          color="gray"
          name="clientType"
          onClick={onClick}
          sx={{ flex: '1 1 100%' }}
          type="submit"
          value={ClientType.Employer}
          variant="primary"
        >
          Помощника
        </Button>
        <Button
          className={cx(EButtonName.SelectClientType, CLIENT_TYPE_TO_CLIENT_TYPE_NAME[ClientType.Specialist])}
          color="pink"
          name="clientType"
          onClick={onClick}
          sx={{ flex: '1 1 100%' }}
          type="submit"
          value={ClientType.Specialist}
          variant="primary"
        >
          Работу
        </Button>
      </Stack>
    </StepContainer>
  );
};
